import { Injectable } from '@angular/core';
// import {Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class EfoUtilService {
  constructor(private router: Router) {}

  go(path: string, event?: any) {
    // return true;
    this.router.navigate([path]);
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  noFollow(event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  // displayPowerBox(ele, data) {
  //     const d = data;
  //     $(ele).sparkline([d.power_idle, d.min_value, d.avg_value, d.max_value, d.power_full_load],
  //         {
  //             type: 'box',
  //             raw: true,
  //             target: d.power_derated,
  //             tooltipValueLookups: {
  //                 fields: {
  //                     lq: 'Min',
  //                     med: 'Avg',
  //                     uq: 'Max',
  //                     lo: 'Left Outlier',
  //                     ro: 'Right Outlier',
  //                     lw: 'Idle',
  //                     rw: 'Full Load'
  //                 }
  //             }
  //         });
  // }
  setBrowserCSSClasses(u) {
    const ua = u.toLowerCase(),
      is = function (t) {
        return ua.indexOf(t) > -1;
      };
    let g = 'gecko';
    const w = 'webkit',
      s = 'safari',
      o = 'opera',
      m = 'mobile',
      i = 'ios';
    g = g + ' firefox';
    const h = document.documentElement;
    const b = [
      !/opera|webtv/i.test(ua) && /msie\s(\d)/.test(ua)
        ? 'ie ie' + RegExp.$1
        : is('firefox/2')
        ? g + ' ff2'
        : is('firefox/3.5')
        ? g + ' ff3 ff3_5'
        : is('firefox/3.6')
        ? g + ' ff3 ff3_6'
        : is('firefox/3')
        ? g + ' ff3'
        : is('firefox/5')
        ? g + ' ff5'
        : is('firefox/6')
        ? g + ' ff6'
        : is('firefox/7')
        ? g + ' ff7'
        : is('firefox/8')
        ? g + ' ff8'
        : is('firefox/9')
        ? g + ' ff9'
        : is('firefox/10')
        ? g + ' ff10'
        : is('gecko/')
        ? g
        : is('opera')
        ? o +
          (/version\/(\d+)/.test(ua)
            ? ' ' + o + RegExp.$1
            : /opera(\s|\/)(\d+)/.test(ua)
            ? ' ' + o + RegExp.$2
            : '')
        : is('konqueror')
        ? 'konqueror'
        : is('blackberry')
        ? m + ' blackberry'
        : is('android')
        ? m + ' android'
        : is('chrome')
        ? w + ' chrome'
        : is('iron')
        ? w + ' iron'
        : is('applewebkit/')
        ? w + ' ' + s + (/version\/(\d+)/.test(ua) ? ' ' + s + RegExp.$1 : '')
        : is('mozilla/')
        ? g
        : '',
      is('j2me')
        ? m + ' j2me'
        : is('iphone')
        ? m + ' iphone'
        : is('ipod')
        ? m + ' ipod'
        : is('ipad')
        ? m + ' ipad'
        : is('mac')
        ? 'mac'
        : is('darwin')
        ? 'mac'
        : is('webtv')
        ? 'webtv'
        : is('win')
        ? 'win' +
          (is('windows nt 5.1')
            ? ' xp'
            : is('windows nt 6.0')
            ? ' vista'
            : is('windows nt 6.1')
            ? ' win7'
            : '')
        : is('freebsd')
        ? 'freebsd'
        : is('x11') || is('linux')
        ? 'linux'
        : '',
      /cpu\sos\s5/.test(ua) ? i + '5' : /cpu\sos\s4/.test(ua) ? i + '4' : '',
      'js',
    ];
    const c = b.join(' ');
    h.className += ' ' + c;
    return c;
  }
}
